<template>
	<div v-loading="loading">
		<div id="wrap1" class="wrap_page fixed">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="企业信息" name="first"></el-tab-pane>
				<el-tab-pane label="经济效益" name="second"></el-tab-pane>
				<el-tab-pane label="专业化程度" name="third"></el-tab-pane>
				<el-tab-pane label="创新能力" name="fourth"></el-tab-pane>
				<el-tab-pane label="经营管理" name="six"></el-tab-pane>
				<el-tab-pane label="资料生成" name="seven"></el-tab-pane>
			</el-tabs>
		</div>

		<div id="wrap2" style="margin-top: 70px" class="wrap_page">
			<div class="text">基本信息</div>
			<div class="content">
				<el-form
					class="ruleForm flex flex-wrap"
					:rules="rules"
					ref="ruleForm1"
					:model="param"
					label-position="top"
				>
					<el-form-item
						prop="zjtxDegreeOSpecializationBasicInformationBO.leadingProductName"
						class="item"
					>
						<span slot="label">
							<span class="span-box">
								<span>主导产品名称（中文）</span>
							</span>
						</span>
						<el-input
							v-model="
								param.zjtxDegreeOSpecializationBasicInformationBO
									.leadingProductName
							"
							placeholder="请输入"
						></el-input>
					</el-form-item>
					<el-form-item
						prop="zjtxDegreeOSpecializationBasicInformationBO.timeSpent"
						class="item"
					>
						<span slot="label">
							<span class="span-box">
								<span>从事该产品领域的时间（单位：年）</span>
							</span>
						</span>
						<el-input
							onkeyup="value=value.replace(/[^[\d]/g,'')"
							v-model="
								param.zjtxDegreeOSpecializationBasicInformationBO.timeSpent
							"
							placeholder="请输入"
						></el-input>
					</el-form-item>
					<el-form-item
						prop="zjtxDegreeOSpecializationBasicInformationBO.leadingProductType"
						class="item"
					>
						<span slot="label">
							<span class="span-box">
								<span>主导产品类别</span>
							</span>
						</span>
						<el-select
							v-model="
								param.zjtxDegreeOSpecializationBasicInformationBO
									.leadingProductType
							"
							placeholder="请选择"
						>
							<el-option
								v-for="item in leadingProductType"
								:key="item.dictCode"
								:label="item.dictName"
								:value="item.dictCode"
							>
							</el-option>
						</el-select>
					</el-form-item>

					<el-form-item
						class="item inputs"
						style="width: 100%"
						prop="zjtxDegreeOSpecializationBasicInformationBO.industryLeaderOne"
					>
						<span slot="label">
							<span class="span-box">
								<span>行业领军企业（3个以内）</span>
							</span>
						</span>
						<el-input
							v-model="
								param.zjtxDegreeOSpecializationBasicInformationBO
									.industryLeaderOne
							"
							placeholder="请输入"
						></el-input>
						<el-input
							v-model="
								param.zjtxDegreeOSpecializationBasicInformationBO
									.industryLeaderTwo
							"
							placeholder="请输入"
						></el-input>
						<el-input
							v-model="
								param.zjtxDegreeOSpecializationBasicInformationBO
									.industryLeaderThree
							"
							placeholder="请输入"
						></el-input>
					</el-form-item>

					<el-form-item
						prop="zjtxDegreeOSpecializationBasicInformationBO.industry"
						class="item"
					>
						<span slot="label">
							<span class="span-box">
								<span>所属行业</span>
							</span>
						</span>
						<el-input
							v-model="
								param.zjtxDegreeOSpecializationBasicInformationBO.industry
							"
							placeholder="注册用户会直接代入"
						></el-input>
					</el-form-item>
					<el-form-item
						label="所属区域"
						label-width="23%"
						:required="true"
						class="items"
					>
						<span slot="label">
							<span class="span-box">
								<span>所属区域</span>
							</span>
						</span>
						<div class="select_box" style="display: flex">
							<el-form-item
								prop="zjtxDegreeOSpecializationBasicInformationBO.province"
							>
								<el-select
									v-model="
										param.zjtxDegreeOSpecializationBasicInformationBO.province
									"
									placeholder="省"
									@change="provinceCchange"
								>
									<el-option
										v-for="dict in province"
										:key="dict.id"
										:label="dict.districtName"
										:value="dict.districtKey"
										placeholder="请选择"
									></el-option>
								</el-select>
							</el-form-item>

							<el-form-item
								prop="zjtxDegreeOSpecializationBasicInformationBO.city"
							>
								<el-select
									v-model="
										param.zjtxDegreeOSpecializationBasicInformationBO.city
									"
									placeholder="市"
									@change="cityCchange"
								>
									<el-option
										v-for="dict in city"
										:key="dict.id"
										:label="dict.districtName"
										:value="dict.districtKey"
										placeholder="请选择"
									></el-option>
								</el-select>
							</el-form-item>

							<el-form-item
								prop="zjtxDegreeOSpecializationBasicInformationBO.counties"
							>
								<el-select
									v-model="
										param.zjtxDegreeOSpecializationBasicInformationBO.counties
									"
									placeholder="区"
								>
									<el-option
										v-for="dict in counties"
										:key="dict.id"
										:label="dict.districtName"
										:value="dict.districtKey"
										placeholder="请选择"
									></el-option>
								</el-select>
							</el-form-item>
						</div>
					</el-form-item>

					<el-form-item
						prop="zjtxDegreeOSpecializationBasicInformationBO.weatherBelongsField"
						class="item inputs"
						style="width: 100%"
					>
						<span slot="label">
							<span class="span-box">
								<span>所属《工业强基工程实施指南（2016-2020年）》领域</span>
							</span>
						</span>
						<el-radio-group v-model="param.zjtxDegreeOSpecializationBasicInformationBO.weatherBelongsField">
							<el-radio v-for="item in guideFieldOne" :key="item.dictCode" :label="item.dictCode">{{item.dictName}}</el-radio>
						</el-radio-group>

					</el-form-item>

					<el-form-item
						prop="zjtxDegreeOSpecializationBasicInformationBO.belongsField"
						class="item inputs"
						style="width: 100%"
					>
						<span slot="label">
							<span class="span-box">
								<span
									>是否属于《工业强基工程实施指南（2016-2020年）》的下列领域</span
								>
							</span>
						</span>
						<el-radio-group  v-model="param.zjtxDegreeOSpecializationBasicInformationBO.belongsField">
							<el-radio v-for="item in guideFieldTwo" :key="item.dictCode" :label="item.dictCode">{{item.dictName}}</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-form>
			</div>
		</div>

		<div id="wrap3" style="margin-top: 15px" class="wrap_page">
			<div class="text">是否在产业链关键领域实现“补短板”，“填空白”</div>
			<div class="content">
				<el-form class="ruleForm flex flex-wrap" label-position="top">
					<el-form-item class="item inputs" style="width: 100%">
						<el-radio
							v-for="item in radioOptions"
							:key="item.value"
							:label="item.value"
							v-model="param.zjtxIsCriticalAreaImproveWeakLinksBO.result"
							@change="radioFn"
							>{{ item.label }}</el-radio
						>
					</el-form-item>
					<el-form-item class="item" v-show="clock">
						<span slot="label">
							<span class="span-box">
								<span>“补短板”的产品名称：</span>
							</span>
						</span>
						<el-input
							v-model="param.zjtxIsCriticalAreaImproveWeakLinksBO.productName"
							placeholder=""
						></el-input>
					</el-form-item>
					<el-form-item class="item" v-show="clock">
						<span slot="label">
							<span class="span-box">
								<span>或填补国内（国际）空白的领域</span>
							</span>
						</span>
						<el-input
							v-model="param.zjtxIsCriticalAreaImproveWeakLinksBO.areaName"
							placeholder="请输入"
						></el-input>
					</el-form-item>
					<el-form-item class="item" v-show="clock">
						<span slot="label">
							<span class="span-box">
								<span>或替代进口的国外企业（或产品）名称</span>
							</span>
						</span>
						<el-input
							v-model="
								param.zjtxIsCriticalAreaImproveWeakLinksBO.foreignCompanyName
							"
							placeholder="请输入"
						></el-input>
					</el-form-item>
					<el-form-item class="item" style="width: 100%" v-show="clock">
						<span slot="label">
							<span class="span-box">
								<span
									>说明（是否在细分领域实现关键技术首创等情况，30字以内）</span
								>
							</span>
						</span>
						<el-input
							type="textarea"
							maxlength="30"
							show-word-limit
							v-model="param.zjtxIsCriticalAreaImproveWeakLinksBO.introduce"
							placeholder="请输入"
						></el-input>
					</el-form-item>
				</el-form>
			</div>
		</div>

		<div id="wrap4" style="margin-top: 15px" class="wrap_page">
			<div class="text">主导产品是否为国内外知名大企业直接配套</div>
			<div class="content">
				<el-form class="ruleForm flex flex-wrap" label-position="top">
					<el-form-item class="item inputs" style="width: 100%">
						<el-radio
							v-for="item in radioOptions"
							:key="item.value"
							:label="item.value"
							v-model="
								param.zjtxLeadingProductIsCorollaryEquipmentBO
									.isFamousEnterprisesEquipment
							"
							@change="radioFn2"
							>{{ item.label }}</el-radio
						>
					</el-form-item>
					<el-form-item class="item" v-show="clock2">
						<span slot="label">
							<span class="span-box">
								<span>企业-1</span>
							</span>
						</span>
						<el-input
							v-model="
								param.zjtxLeadingProductIsCorollaryEquipmentBO.enterpriseOne
							"
							placeholder=""
						></el-input>
					</el-form-item>
					<el-form-item class="item" v-show="clock2">
						<span slot="label">
							<span class="span-box">
								<span>企业-2</span>
							</span>
						</span>
						<el-input
							v-model="
								param.zjtxLeadingProductIsCorollaryEquipmentBO.enterpriseTwo
							"
							placeholder="请输入"
						></el-input>
					</el-form-item>
					<el-form-item class="item" v-show="clock2">
						<span slot="label">
							<span class="span-box">
								<span>企业-3</span>
							</span>
						</span>
						<el-input
							v-model="
								param.zjtxLeadingProductIsCorollaryEquipmentBO.enterpriseThree
							"
							placeholder="请输入"
						></el-input>
					</el-form-item>
					<el-form-item class="item" style="width: 100%" v-show="clock2">
						<div>配套协议</div>
						<div>
							附件说明：附件最多可上传3个文件，单个文件大小不超过10M，格式为PDF，DOC，DOCX
						</div>
						<el-upload
							class="upload-demo"
							:action="uploadImgUrl"
							:on-remove="handleRemove"
							:before-remove="beforeRemove"
							accept=".pdf,.doc,.docx"
							:before-upload="beforeUploadZjtx"
							:on-success="uploadSuccess"
							:data="{ moduleType: 3 }"
							:on-exceed="handleExceed"
							:file-list="fileList"
							:on-preview="handleView"
							:limit="limit"
							:on-error="uploadError"
						>
							<el-button size="small" type="primary"
								><i class="el-icon-upload"></i> 点击上传</el-button
							>
						</el-upload>
					</el-form-item>
				</el-form>
			</div>
		</div>

		<div id="wrap" style="margin-top: 15px" class="wrap_page">
			<div class="text">重要指标</div>
			<div class="content">
				<div class="item flex flex-around">
					<div></div>
					<div>{{ param.zjtxAnnualImportantIndicatorsBO[0].annual }}年</div>
					<div>{{ param.zjtxAnnualImportantIndicatorsBO[1].annual }}年</div>
					<!--          <div>2020年</div>-->
				</div>
				<div class="item flex flex-around">
					<div>主导产品国内市场占有率</div>
					<div>
						<el-input
							onkeyup="value=value.replace(/[^[\d.]/g,'')"
							v-model="
								param.zjtxAnnualImportantIndicatorsBO[0]
									.leadingProductDomesticMarketShare
							"
							placeholder="请输入"
						></el-input>
					</div>
					<div>
						<el-input
							onkeyup="value=value.replace(/[^[\d.]/g,'')"
							v-model="
								param.zjtxAnnualImportantIndicatorsBO[1]
									.leadingProductDomesticMarketShare
							"
							placeholder="请输入"
						></el-input>
					</div>
				</div>
				<div class="item flex flex-around">
					<div>主导产品本省/直辖市排名</div>
					<div>
						<el-input
							onkeyup="value=value.replace(/[^[\d.]/g,'')"
							v-model="
								param.zjtxAnnualImportantIndicatorsBO[0]
									.leadingProductRankingInProvince
							"
							placeholder="请输入"
						></el-input>
					</div>
					<div>
						<el-input
							onkeyup="value=value.replace(/[^[\d.]/g,'')"
							v-model="
								param.zjtxAnnualImportantIndicatorsBO[1]
									.leadingProductRankingInProvince
							"
							placeholder="请输入"
						></el-input>
					</div>
				</div>
				<div class="item flex flex-around">
					<div>主导产品销售收入占本企业营业收入比重</div>
					<div>
						<el-input
							onkeyup="value=value.replace(/[^[\d.]/g,'')"
							v-model="
								param.zjtxAnnualImportantIndicatorsBO[0]
									.leadingProductRevenueInBusinessRevenue
							"
							placeholder="请输入"
						></el-input>
					</div>
					<div>
						<el-input
							onkeyup="value=value.replace(/[^[\d.]/g,'')"
							v-model="
								param.zjtxAnnualImportantIndicatorsBO[1]
									.leadingProductRevenueInBusinessRevenue
							"
							placeholder="请输入"
						></el-input>
					</div>
				</div>
				<div class="item flex flex-around">
					<div>主导产品出口额</div>
					<div>
						<el-input
							onkeyup="value=value.replace(/[^[\d.]/g,'')"
							v-model="
								param.zjtxAnnualImportantIndicatorsBO[0]
									.leadingProductAmountOfExport
							"
							placeholder="请输入"
						></el-input>
					</div>
					<div>
						<el-input
							onkeyup="value=value.replace(/[^[\d.]/g,'')"
							v-model="
								param.zjtxAnnualImportantIndicatorsBO[1]
									.leadingProductAmountOfExport
							"
							placeholder="请输入"
						></el-input>
					</div>
				</div>
			</div>
		</div>

		<div class="flex flex-center" style="margin-top:20px;">
			<el-button type="primary" @click="save()">保存</el-button>
			<el-button type="primary" @click="reset()">重置</el-button>
			<el-button type="primary" @click="nextPage()">下一项</el-button>
		</div>
	</div>
</template>

<script>
import {
	getDict,
	queryDictDataByTypeAndCode,
	getDistrictByParentId,
	getDistrictByKey,
	getModuleFiles
} from "@/api/ChinaHigh";
import {
	saveDegreeSpecialization,
	getBaseProfessionalInfo
} from "@/api/specialization";
export default {
	data() {
		return {
			loading: false,
			activeName: "third",
			clock: true,
			clock2: true,
			rules: {
				"zjtxDegreeOSpecializationBasicInformationBO.industryLeaderOne": [
					{ required: true, message: "请至少填写一个", trigger: "blur" }
				],
				"zjtxDegreeOSpecializationBasicInformationBO.leadingProductName": [
					{ required: true, message: "请输入主导产品名称", trigger: "blur" }
				],
				"zjtxDegreeOSpecializationBasicInformationBO.timeSpent": [
					{
						required: true,
						message: "请输入从事该产品领域的时间",
						trigger: "blur"
					}
				],
				"zjtxDegreeOSpecializationBasicInformationBO.leadingProductType": [
					{ required: true, message: "请输入主导产品类别", trigger: "change" }
				],
				"zjtxDegreeOSpecializationBasicInformationBO.industry": [
					{ required: true, message: "请输入所属行业", trigger: "blur" }
				],
				"zjtxDegreeOSpecializationBasicInformationBO.province": [
					{ required: true, message: "请选择省", trigger: "change" }
				],
				"zjtxDegreeOSpecializationBasicInformationBO.city": [
					{ required: true, message: "请选择市", trigger: "change" }
				],
				"zjtxDegreeOSpecializationBasicInformationBO.counties": [
					{ required: true, message: "请选择区域", trigger: "change" }
				],
				"zjtxDegreeOSpecializationBasicInformationBO.weatherBelongsField": [
					{ required: true, message: "请选择所属领域", trigger: "change",type:"number" }
				],
				"zjtxDegreeOSpecializationBasicInformationBO.belongsField": [
					{ required: true, message: "请选择所属领域", trigger: "change",type:"number" }
				]
			},
			limit: 3,
			value: [],
			radioOptions: [
				{ value: 1, label: "是" },
				{ value: 2, label: "否" }
			],
			guideFieldOne: [],
			guideFieldTwo: [],
			fileList: [],
			param: {
				zjtxProjectBO: { id: "" },
				zjtxLeadingProductIsCorollaryEquipmentBO: { id: "" },
				zjtxIsCriticalAreaImproveWeakLinksBO: { id: "" },
				zjtxDegreeOSpecializationBasicInformationBO: { id: "" },
				zjtxAnnualImportantIndicatorsBO: [{ id: "" }, { id: "" }],
				files: []
			},
			counties: [],
			province: [],
			city: [],
			leadingProductType: []
		};
	},
	created() {
		this.init();
	},
	methods: {
		radioFn(e) {
			console.log(e);
			if (e == 2) {
				this.clock = false;
			} else {
				this.clock = true;
			}
		},
		radioFn2(e) {
			console.log(e);
			if (e == 2) {
				this.clock2 = false;
			} else {
				this.clock2 = true;
			}
		},
		reset() {
			this.param.zjtxProjectBO = { id: this.param.zjtxProjectBO.id };
			this.param.zjtxLeadingProductIsCorollaryEquipmentBO = {
				id: this.param.zjtxLeadingProductIsCorollaryEquipmentBO.id
			};
			this.param.zjtxIsCriticalAreaImproveWeakLinksBO = {
				id: this.param.zjtxIsCriticalAreaImproveWeakLinksBO.id
			};
			this.param.zjtxDegreeOSpecializationBasicInformationBO = {
				id: this.param.zjtxDegreeOSpecializationBasicInformationBO.id
			};
			this.param.zjtxAnnualImportantIndicatorsBO = [
				{
					id: this.param.zjtxAnnualImportantIndicatorsBO[0].id,
					annual: this.param.zjtxAnnualImportantIndicatorsBO[0].annual
				},
				{
					id: this.param.zjtxAnnualImportantIndicatorsBO[1].id,
					annual: this.param.zjtxAnnualImportantIndicatorsBO[1].annual
				}
			];
			this.param.files = [];
			this.fileList = [];
		},
		nextPage() {
			this.$refs["ruleForm1"].validate(valid => {
				if (valid) {
					this.loading = true;
					console.log(this.param);
					// zjtxDegreeOSpecializationBasicInformationBO
					saveDegreeSpecialization(this.param).then(res => {
						this.loading = false;
						if (res.code == "00000") {
							if (res.data != null) {
								// console.log(res.data);
								this.param.zjtxAnnualImportantIndicatorsBO[0].id =
										res.data.AnnualImportantIndicators0;
								this.param.zjtxAnnualImportantIndicatorsBO[1].id =
										res.data.AnnualImportantIndicators1;
								this.param.zjtxLeadingProductIsCorollaryEquipmentBO.id =
										res.data.LeadingProductIsCorollaryEquipment;
								this.param.zjtxDegreeOSpecializationBasicInformationBO.id =
										res.data.DegreeOSpecializationBasicInformation;
								this.param.zjtxIsCriticalAreaImproveWeakLinksBO.id =
										res.data.IsCriticalAreaImproveWeakLinks;
							}
							this.msgSuccess("操作成功");
							this.$router.push("/centerform/specializationInnovationCapacity");
						} else {
							this.msgError(res.code + ":" + res.msg);
						}
					});
				}
			});
		},
		getBaseProfessionalInfo() {
			this.loading = true;
			getBaseProfessionalInfo(sessionStorage.getItem("zt_special_id")).then(
				res => {
					this.loading = false;
					this.param.zjtxAnnualImportantIndicatorsBO =
						res.data.zjtxAnnualImportantIndicatorsBO;
					if (res.data.zjtxDegreeOSpecializationBasicInformationBO != null) {
						// console.log(res.zjtxDegreeOSpecializationBasicInformationBO);
						this.param.zjtxDegreeOSpecializationBasicInformationBO =
							res.data.zjtxDegreeOSpecializationBasicInformationBO;
						this.param.zjtxIsCriticalAreaImproveWeakLinksBO =
							res.data.zjtxIsCriticalAreaImproveWeakLinksBO;
						this.param.zjtxLeadingProductIsCorollaryEquipmentBO = res.data
							.zjtxLeadingProductIsCorollaryEquipmentBO
							? res.data.zjtxLeadingProductIsCorollaryEquipmentBO
							: {};
						if (
							res.data.zjtxDegreeOSpecializationBasicInformationBO.province !==
								"" &&
							res.data.zjtxDegreeOSpecializationBasicInformationBO.province !==
								null
						) {
							this.quyu(
								res.data.zjtxDegreeOSpecializationBasicInformationBO.province,
								1,
								2
							);
						}
						if (
							res.data.zjtxDegreeOSpecializationBasicInformationBO.city !==
								"" &&
							res.data.zjtxDegreeOSpecializationBasicInformationBO.city !== null
						) {
							this.quyu(
								res.data.zjtxDegreeOSpecializationBasicInformationBO.city,
								2,
								2
							);
						}
						this.loading = true;
						getModuleFiles({
							moduleId: sessionStorage.getItem("zt_special_id"),
							moduleType: 3
						}).then(res => {
							this.loading = false;
							// console.log(res);
							this.param.files = res.data;
							this.fileList = [];
							res.data.forEach(re => {
								this.fileList.push({
									name: re.fileName,
									fileName: re.fileName,
									url: re.url,
									moduleId: re.moduleId,
									moduleType: re.moduleType,
									path: re.path,
									id: re.id
								});
							});
						});
					}
					if (this.param.zjtxIsCriticalAreaImproveWeakLinksBO.result == 1) {
						this.clock = true;
					} else {
						this.clock = false;
					}

					if (
						this.param.zjtxLeadingProductIsCorollaryEquipmentBO
							.isFamousEnterprisesEquipment == 1
					) {
						this.clock2 = true;
					} else {
						this.clock2 = false;
					}
				}
			);
		},
		save() {
			this.$refs["ruleForm1"].validate(valid => {
				if (valid) {
					this.loading = true;
					console.log(this.param);
					// zjtxDegreeOSpecializationBasicInformationBO
					saveDegreeSpecialization(this.param).then(res => {
						this.loading = false;
						if (res.code == "00000") {
							if (res.data != null) {
								// console.log(res.data);
								this.param.zjtxAnnualImportantIndicatorsBO[0].id =
									res.data.AnnualImportantIndicators0;
								this.param.zjtxAnnualImportantIndicatorsBO[1].id =
									res.data.AnnualImportantIndicators1;
								this.param.zjtxLeadingProductIsCorollaryEquipmentBO.id =
									res.data.LeadingProductIsCorollaryEquipment;
								this.param.zjtxDegreeOSpecializationBasicInformationBO.id =
									res.data.DegreeOSpecializationBasicInformation;
								this.param.zjtxIsCriticalAreaImproveWeakLinksBO.id =
									res.data.IsCriticalAreaImproveWeakLinks;
							}
							this.msgSuccess("操作成功");
						} else {
							this.msgError(res.code + ":" + res.msg);
						}
					});
				}
			});
		},
		init() {
			this.getBaseProfessionalInfo();
			//省
			getDistrictByParentId({ parentId: 0 }).then(res => {
				this.province = res.data;
			});
			//主导产品类别
			getDict({ type: "leading_product_type" }).then(res => {
				this.leadingProductType = res.data;
			});
			//所属指南领域1
			getDict({ type: "guide_field_one" }).then(res => {
				this.guideFieldOne = res.data;
			});
			//所属指南领域2
			getDict({ type: "guide_field_two" }).then(res => {
				this.guideFieldTwo = res.data;
			});
			this.param.zjtxProjectBO.id = sessionStorage.getItem("zt_special_id");
		},
		provinceCchange(val) {
			this.quyu(val, 1, 1);
		},
		cityCchange(val) {
			this.quyu(val, 2, 1);
		},
		// 区域
		quyu(val, type, stauts) {
			getDistrictByKey({ key: val }).then(res => {
				if (type == 1) {
					if (stauts == 1) {
						this.counties = {};
						this.$set(
							this.param.zjtxDegreeOSpecializationBasicInformationBO,
							"city",
							""
						);
						this.$set(
							this.param.zjtxDegreeOSpecializationBasicInformationBO,
							"counties",
							""
						);
					}
					this.city = res.data;
				} else {
					if (stauts == 1) {
						this.$set(
							this.param.zjtxDegreeOSpecializationBasicInformationBO,
							"counties",
							""
						);
					}
					this.counties = res.data;
				}
			});
		},
		beforeUploadZjtx(file, fileList) {
			let suffix = file.name.substring(file.name.lastIndexOf(".") + 1);
			if (suffix != "pdf" && suffix != "doc" && suffix != "docx") {
				this.msgError("只能上传pdf/doc/docx格式的文件");
				return false;
			}
			if (file.size > 10240000) {
				this.msgError("文件最大可上传10MB,您上传的" + file.name + "已超出限制");
				return false;
			}
			// this.loading = true;
		},
		uploadSuccess(res, file) {
			this.loading = false;
			console.log(this.fileList);
			if (res.code == "00000") {
				this.param.files.push(res.data);
			}
			this.msgSuccess("上传成功");
		},
		handleClick(tab, event) {
			console.log(tab.index);
			this.$confirm(
				"请确认当前页数据是否填写完整并保存,否则将导致数据丢失",
				"确认离开吗?",
				{ type: "warning" }
			)
				.then(() => {
					if (tab.index == 0) {
						this.$router.push("/centerform/specializationRegistration");
					} else if (tab.index == 1) {
						this.$router.push("/centerform/specializationBenefit");
					} else if (tab.index == 2) {
						this.$router.push("/centerform/specializationProfessionalization");
					} else if (tab.index == 3) {
						this.$router.push("/centerform/specializationInnovationCapacity");
					} else if (tab.index == 4) {
						this.$router.push("/centerform/specializationManagement");
					} else if (tab.index == 5) {
						this.$router.push("/centerform/specializationDatagenerated");
					}
				})
				.catch(e => {
					this.activeName = "third";
				});
		},

		handleRemove(file, fileList) {
			this.param.files = [];
			fileList.forEach(res => {
				console.log(res);
				if (res.response == undefined) {
					this.param.files.push(res);
				} else {
					this.param.files.push(res.response.data);
				}
			});
			console.log(this.param.files);
		},
		handlePreview(file) {
			console.log(file);
		},
		handleExceed(files, fileList) {
			this.$message.warning(`最多上传三个文件`);
		},
		beforeRemove(file, fileList) {},
		uploadError() {
			this.msgError("上传失败");
			this.loading = false;
		}
	}
};
</script>

<style scoped>
.text {
	border-bottom: 1px solid #dbdbdb;
	position: relative;
	padding: 10px 20px;
}
.text::before {
	content: "";
	position: absolute;
	width: 4px;
	height: 18px;
	left: 10px;
	top: 12px;
	background: #7c99fd;
}
.ruleForm {
	width: 80%;
	margin-left: 10%;
}
.ruleForm .item {
	width: 50%;
}
.ruleForm .items {
	width: 50%;
}
.ruleForm .item .el-select,
.ruleForm .item .el-input,
.ruleForm .item .el-cascader {
	width: 50%;
}
.ruleForm .items .el-select {
	width: 70%;
}
.iconfont {
	color: #d43030;
}
.ruleForm .inputs .el-input {
	width: 25%;
	margin-right: 8%;
}
.flex-around > div {
	flex: 1;
	margin-top: 20px;
}
.flex-around > div .el-input {
	width: 50%;
}
</style>
